// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@2.3.1_@swc+helpers@0.5.23__webpack@5.104.1_@swc+core@1.15_5c916327c7a1e0ea96b4ad86b04a02b8/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@2.3.1_@swc+helpers@0.5.23__webpack@5.104.1_@swc+core@1.15_5c916327c7a1e0ea96b4ad86b04a02b8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eW8e6bezl9oxZKBZ {
	display: flex;
	align-items: center;
	gap: var(--lp-spacing-300);
	overflow: hidden;
	width: 100%;

	&:has(input[data-rac]:not([disabled])) {
		cursor: text;

		& :where(button, [role='button']) {
			cursor: default;
		}
	}

	&:has([slot='increment'], [slot='decrement']) {
		gap: 0;
	}

	&:has(button[data-rac]) {
		padding-block: 3px;
	}

	&[data-focus-within] {
		outline: 2px solid var(--lp-color-shadow-interactive-focus);
		outline-offset: -2px;
		z-index: 1;
	}

	& input[data-rac],
	[role='presentation'][data-rac] {
		padding: 0;
		outline: none;
		border: none;
		border-radius: unset;
		background-color: inherit;
		cursor: inherit;
	}

	& :where(input[data-rac]) + [data-icon]:not([data-validation-icon]),
	& :where([data-input-slot]) + [data-icon]:not([data-validation-icon]) {
		fill: var(--lp-color-fill-ui-secondary);
	}

	& input[data-rac]:has(+ [data-validation-icon]) {
		padding-inline-end: var(--lp-spacing-700);
	}

	&[data-disabled] > :where([data-icon]) {
		opacity: 0.64;
	}
}
`, "",{"version":3,"sources":["webpack://./../../launchpad-ui/packages/components/src/styles/Group.module.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,mBAAmB;CACnB,0BAA0B;CAC1B,gBAAgB;CAChB,WAAW;;CAEX;EACC,YAAY;;EAEZ;GACC,eAAe;EAChB;CACD;;CAEA;EACC,MAAM;CACP;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,2DAA2D;EAC3D,oBAAoB;EACpB,UAAU;CACX;;CAEA;;EAEC,UAAU;EACV,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,eAAe;CAChB;;CAEA;;EAEC,uCAAuC;CACxC;;CAEA;EACC,yCAAyC;CAC1C;;CAEA;EACC,aAAa;CACd;AACD","sourcesContent":[".group {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: var(--lp-spacing-300);\n\toverflow: hidden;\n\twidth: 100%;\n\n\t&:has(input[data-rac]:not([disabled])) {\n\t\tcursor: text;\n\n\t\t& :where(button, [role='button']) {\n\t\t\tcursor: default;\n\t\t}\n\t}\n\n\t&:has([slot='increment'], [slot='decrement']) {\n\t\tgap: 0;\n\t}\n\n\t&:has(button[data-rac]) {\n\t\tpadding-block: 3px;\n\t}\n\n\t&[data-focus-within] {\n\t\toutline: 2px solid var(--lp-color-shadow-interactive-focus);\n\t\toutline-offset: -2px;\n\t\tz-index: 1;\n\t}\n\n\t& input[data-rac],\n\t[role='presentation'][data-rac] {\n\t\tpadding: 0;\n\t\toutline: none;\n\t\tborder: none;\n\t\tborder-radius: unset;\n\t\tbackground-color: inherit;\n\t\tcursor: inherit;\n\t}\n\n\t& :where(input[data-rac]) + [data-icon]:not([data-validation-icon]),\n\t& :where([data-input-slot]) + [data-icon]:not([data-validation-icon]) {\n\t\tfill: var(--lp-color-fill-ui-secondary);\n\t}\n\n\t& input[data-rac]:has(+ [data-validation-icon]) {\n\t\tpadding-inline-end: var(--lp-spacing-700);\n\t}\n\n\t&[data-disabled] > :where([data-icon]) {\n\t\topacity: 0.64;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"group": `eW8e6bezl9oxZKBZ`
};
export default ___CSS_LOADER_EXPORT___;
